module.exports = "<div class=\"kng-content {{additionalClasses}}\" #contentElement>\r\n  <div class=\"container\">\r\n    <ng-content></ng-content>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/cot-web/src/app/layout/kingswell/kng-content/kng-content.component.html
// module id = ../../../../../src/app/layout/kingswell/kng-content/kng-content.component.html
// module chunks = main